import vs from './default-raw-vs.glsl'
import fs from './dither-three.glsl'

const DitherShader = {
  uniforms: {
    tDiffuse: { value: null },
  },
  vertexShader: vs,
  fragmentShader: fs,
}

export { DitherShader }
